// in credits
export const MAX_TOPUP_AMOUNT = 20000;

// in dollars
export const MIN_TOPUP_AMOUNT = 5;
export const MIN_LOWER_LIMIT = 1;
export const MIN_UPPER_LIMIT = 5;

// credits per dollar
export const CREDITS_PER_DOLLAR = 4;

interface HandleNumberInputProps {
  userValue: number | string;
  minValue: number;
  maxValue?: number;
}

export const handleNumberInput = ({
  userValue,
  minValue,
  maxValue
}: HandleNumberInputProps) => {
  let value = Number(userValue);
  if (isNaN(value) || value < minValue) {
    value = minValue;
  } else if (maxValue !== undefined && value > maxValue) {
    value = maxValue;
  }
  value = Math.ceil(value);
  return value;
};
